<template>
    <div class="wrapper-body flex-1">
        <v-dialog v-model="manageUserSignaturesDialog" content-class="fullscreen-dialog" fullscreen>
            <div class="dialog-header">
                <v-toolbar class="bg-white">
                    <h1 class="mb-0">
                        {{ $t("res_Lable_ManageSignatures") }}
                    </h1>
                    <v-spacer></v-spacer>
                    <div class="custom-icon-wrapper">
                        <v-icon @click="manageUserSignaturesDialog = false">custom-icon mdi-close</v-icon>
                    </div>
                </v-toolbar>
            </div>
            <div class="dialog-body">
                <UserSignatureManager :dialogModelShow="manageUserSignaturesDialog"
                    v-on:closeDialog="manageUserSignaturesDialog = false"></UserSignatureManager>
            </div>
        </v-dialog>
        <v-dialog v-model="profileDialog" content-class="profile-dialog m-0" width="380px"
            @keydown.esc="closeManageUserSignaturesDialog" @click:outside="closeManageUserSignaturesDialog">
            <v-card style="padding-bottom: 0px">
                <v-card-title class="p-0" style="margin-bottom: 1.75rem; line-height: 1.5rem">
                    {{ $t("res_DialogHeaders_Profile") }}
                </v-card-title>
                <v-card-text>
                    <div class="mt-1">
                        <label>{{ $t("res_DisplayNameTitle") }}: &nbsp;</label>
                        <label style="font-weight: 500">{{ this.userDisplayName }}</label>
                    </div>
                    <div class="mt-3">
                        <label>{{ $t("res_MenuItems_Email") }}: &nbsp;</label>
                        <label style="font-weight: 500">{{ this.userEmail }}</label>
                    </div>
                </v-card-text>
                <div>
                    <v-divider></v-divider>
                    <nav>
                        <div class="row d-flex justify-content-center">
                            <div class="col-6 profile-icons-container profileIconsCustom"
                                @click="openManageUserSignaturesDialog">
                                <a><v-icon>mdi-manage-signature</v-icon></a>
                                <label>{{ $t("res_Lable_ManageSignatures") }}</label>
                            </div>
                            <div class="col-6 profile-icons-container profileIconsCustom"
                                @click="openManageProfileDialog">
                                <a> <v-icon>mdi-account</v-icon></a>
                                <label>{{ $t("res_Label_EditProfile") }}</label>
                            </div>
                        </div>
                        <div class="row d-flex justify-content-center">

                        </div>
                    </nav>
                </div>
                <v-divider></v-divider>
                <v-card-actions class="p-0">
                    <v-spacer></v-spacer>
                    <v-btn class="mb-3 line-height-20" color="primary" width="100px" @click="logout()">
                        {{ $t("res_MenuItems_Logout") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="manageProfileDialog" width="35%" height="30%" @click:outside="closeManageProfileDialog">
            <v-card>
                <v-card-title>
                    {{ $t("res_Label_EditProfile") }}
                </v-card-title>
                <v-card-text>
                    <v-form ref="form" v-model="formValid">
                        <v-row class="my-3 ml-0">
                            <v-col cols="6" :sm="6">
                                <label>{{ $t("res_Label_FirstName") }} <span style="color: red"> *</span></label>
                                <v-text-field solo v-model="user.firstName"
                                    :rules="[requiredRule(), englishOnlyRule()]"></v-text-field>
                            </v-col>
                            <v-col cols="6" :sm="6">
                                <label>{{ $t("res_Label_LastName") }} <span style="color: red"> *</span></label>
                                <v-text-field solo v-model="user.lastName"
                                    :rules="[requiredRule(), englishOnlyRule()]"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="my-3 ml-0">
                            <v-col cols="6" :sm="6">
                                <label>{{ $t("res_Label_FirstNameAr") }} <span style="color: red"> *</span></label>
                                <v-text-field solo v-model="user.firstNameAr"
                                    :rules="[requiredRule(), arabicOnlyRule()]"></v-text-field>
                            </v-col>
                            <v-col cols="6" :sm="6">
                                <label>{{ $t("res_Label_LastNameAr") }} <span style="color: red"> *</span></label>
                                <v-text-field solo v-model="user.lastNameAr"
                                    :rules="[requiredRule(), arabicOnlyRule()]"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="my-3 ml-0">
                            <v-col cols="6" :sm="6">
                                <label>{{ $t("res_Label_Profession") }} <span style="color: red"> *</span></label>
                                <v-text-field solo v-model="user.profession"
                                    :rules="[requiredRule(), englishOnlyRule()]"></v-text-field>
                            </v-col>
                            <v-col cols="6" :sm="6">
                                <label>{{ $t("res_Label_ProfessionAr") }} <span style="color: red"> *</span></label>
                                <v-text-field solo v-model="user.professionAr"
                                    :rules="[requiredRule(), arabicOnlyRule()]"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="my-3 ml-0">
                            <v-col cols="12" :sm="12">
                                <label>{{ $t("res_MenuItems_Email") }} <span style="color: red"> *</span></label>
                                <v-text-field solo v-model="user.emailId"
                                    :rules="[requiredRule(), validEmailRule()]"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn width="100" class="primary white--text" @click="editProfile()">{{ $t("res_ButtonText_Submit")
                        }}</v-btn>

                    <v-btn color="light-blue" width="100" @click="closeManageProfileDialog()">{{
                        $t("res_ButtonText_Cancel")
                        }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from "axios";

import UserSignatureManager from '@/components/UserSignatureManager.vue'
export default {
    name: 'ProfileView',
    components: { axios, UserSignatureManager },
    data() {
        return {
            formValid: false,
            profileDialog: false,
            user: null,
            userDisplayName: '',
            userEmail: '',
            manageUserSignaturesDialog: false,
            manageProfileDialog: false,
            userid: '',
        }
    },
    mounted() {
        this.openProfileBox();
    },
    methods: {
        requiredRule() {
            return v => !!v || this.$t('res_RequiredFields');
        },
        validEmailRule() {
            return v => /.+@.+\..+/.test(v) || this.$t('res_Msgs_InvalidEmail');
        },
        arabicOnlyRule() {
            const arabicRegex = /^[\u0600-\u06FF\s]+$/;
            return v =>
                !v || arabicRegex.test(v) || this.$t('res_alert_committee_draft_error_only_arabic');
        },
        englishOnlyRule() {
            const englishRegex = /^[A-Za-z\s]+$/;
            return v =>
                !v || englishRegex.test(v) || this.$t('res_alert_committee_draft_error_only_english');
        },
        openManageUserSignaturesDialog() {
            this.manageUserSignaturesDialog = true;
        },
        closeManageUserSignaturesDialog() {
            this.manageUserSignaturesDialog = false;
            this.$router.push({ name: 'inbox' });
        },
        openManageProfileDialog() {
            this.manageProfileDialog = true;
        },
        closeManageProfileDialog() {
            this.manageProfileDialog = false;
        },
        editProfile() {
            window.showLoading();
            if (!this.$refs.form.validate()) {
                // Form is invalid, Vuetify will show messages
                window.hideLoading();

                return;
            }
            axios.post(sessionStorage.getItem('customApiPath') + 'User/UpdateUser', this.user)
                .then(response => {
                    if (response.data != null && response.data === true) {
                        window.showAlert(this.$t("res_Msgs_ChangesSavedSuccess"), 'success');
                    }
                    else {
                        window.showAlert('res_Msgs_ErrorOccured', 'error');
                    }
                    window.hideLoading();
                    this.closeManageProfileDialog();
                })
                .catch(err => {
                    window.showAlert('res_Msgs_ErrorOccured', 'error');
                    window.hideLoading();
                });
        },
        openProfileBox() {
            axios.get(sessionStorage.getItem('customApiPath') + 'User/GetCurrentUserInfo')
                .then(res => {
                    if (res.data.success) {
                        this.user = res.data.data;
                        debugger;
                        let data = res.data.data;
                        this.userDisplayName = data.displayName
                        this.userEmail = data.emailId;
                        this.profileDialog = !this.profileDialog;
                        this.userId = data.id;
                    } else {
                        // this.logout();
                    }
                })
                .catch(err => {
                    // this.logout();
                });

        },
        logout() {
            localStorage.removeItem("user");
            localStorage.removeItem('jwt_token');
            sessionStorage.clear();
            if (this.$route.name !== "login") {
                this.$router.push({ name: "login" });
                window.location.reload();
            }
        },
    }
}
</script>
<style>
.v-text-field__details {
    display: block !important;
}
</style>